export default "__VITE_ASSET__Dy82yeBp__"